import { AppState } from "../../types/app-state";

export const getInitialState = (): AppState => {
  return {
    loader: {
      isLoading: true,
      message: "",
      customImage: undefined,
    },

    accessToken: undefined,
    refreshToken: undefined,
    sessionId: undefined,
    expiresAt: null,
    hasHydrated: false,
    authLoading: false,
    authError: null,
    authUserInfo: null,
    accountType: "",

    userDetails: {
      isLoading: false,
      error: null,
      data: null,
    },

    rubickResponse: {
      userProfile: null,
      rubickToken: null,
    },
  };
};
